import { Link} from "react-router";
import {useState} from "react";
import env from "react-dotenv";

const Templates = () => {
        const [Templates, SetTemplates] = useState(undefined);
    useState(()=>{
        (async function(){
            const resp = await fetch((env.REACT_APP_ENV ==="PROD" ? env.REACT_APP_BH_PROD : env.REACT_APP_BH_DEV) + "/get-templates");
            if(resp.status === 200){
                const results = await resp.json();
                console.log(results)
                SetTemplates(results);
            }
        })();
    }, []);

    return (
        <>
            <div className="GradientBackGround" style={{ minHeight: '100vh' }}>
                <div>
                    <h1 className="CenterText SubBack" >
                        Browse and select a template designed to match your objectives.
                    </h1>
                    {
                        Templates ? 

                        Templates['templates'].map((item, index)=>
                            <Link key={index} to={"/templates/stage/" + item['name']}>
                                <img src={(env.REACT_APP_ENV === "PROD" ? env.REACT_APP_BH_PROD: env.REACT_APP_BH_DEV )+ item['image']} style={{width:"30vw", height : "30vw"}} alt={item['image']}/>
                            </Link>
                        )
                        
                        : 
                        
                        "not yet"
                    }
                </div>
            </div>
        </>
    )
}

export default Templates;